export const externalApprovalMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  Approving_User__c: 'approvingUser',
  Cast_on_portal__c: 'castOnPortal',
  Conflict_of_interest__c: 'conflictOfInterest',
  CreatedById: 'createdById',
  CreatedDate: 'createdDate',
  Entity_Type__c: 'entityType',
  IsDeleted: 'isDeleted',
  LastModifiedById: 'lastModifiedById',
  LastModifiedDate: 'lastModifiedDate',
  LastReferencedDate: 'lastReferencedDate',
  LastViewedDate: 'lastViewedDate',
  Opportunity__c: 'opportunityId',
  Override_Processed__c: 'overrideProcessed',
  Override__c: 'override',
  OwnerId: 'ownerId',
  P_GAP_Grant_Application__c: 'grantApplicationId',
  Reason__c: 'reason',
  Result__c: 'result',
  Stage__c: 'stage',
  SystemModstamp: 'systemModstamp',
  Vote_Y_N_Q_A__c: 'vote'
}

export interface ExternalApproval {
  id: string
  name: string
  approvingUser?: string
  castOnPortal?: boolean
  conflictOfInterest?: string
  createdById?: string
  createdDate?: string
  entityType?: string
  isDeleted?: boolean
  lastModifiedById?: string
  lastModifiedDate?: string
  lastReferencedDate?: string | null
  lastViewedDate?: string | null
  opportunityId?: string
  overrideProcessed?: boolean
  override?: boolean
  ownerId?: string
  grantApplicationId?: string
  reason?: string | null
  result?: string | null
  stage?: string
  systemModstamp?: string
  vote?: string
}
